import React, { useState } from "react";
import { APIConnector } from 'src/api/APIConnector';

const ResetPassword = ({activeSite, onReset}) => {
    const api = APIConnector();
    
    const [reset, setReset] = useState(false);
    const [resetting, setResetting] = useState(false);
    const [clientShortName,  setClientShortName] = useState("");
    const [emailAddress, setEmailAddress] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();

        setResetting(true);

        api.post('/web/reset-pwd', { clientShortName, emailAddress })
            .then(() => {
                setReset(true);

                setTimeout(() => {
                    setResetting(false);
                    alert('Reset Password Email Sent.');
                }, 5000);
                
                setResetting(false);
            });
    }

    if(reset)
    return (<div align="center" style={{minHeight:250}}><br/>
        <b>Password Reset</b>
        <p>If there is an account associated with the email you've entered, you will receive an email with instructions to reset your password shortly.</p>
        <br/><br/>
        <button className="whiteBtn" onClick={onReset}>Return To Login</button>
        <div style={{height:40}}>&nbsp;</div>
    </div>)
    else
    return (<div align="center" style={{minHeight:250}}><br/>
        <b>Password Reset</b>
        <p>Enter the {activeSite == 'CLIENT' && 'company short name and'} email address associated with your account.</p>        
        <form onSubmit={handleSubmit}>
        <table border="0" cellSpacing={5} width="75%">
        <tbody>
        {activeSite == 'CLIENT' &&
            <tr>
                <td><input id="shortName" className="stretch" placeholder="Company Short Name" required value={clientShortName} onChange={(e) => setClientShortName(e.target.value)} /></td>
            </tr>}
            <tr>
                <td><input id="emailAddress" className="stretch" placeholder="Email Address" required value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} /></td>
            </tr>
        </tbody>
        </table>
        <br/>
        <button type="button" className="whiteBtn" onClick={onReset}>Return To Login</button> &nbsp;
        <button type="submit" className="redBtn" disabled={resetting}>Reset Password</button> 
        </form>
        {activeSite != 'CLIENT' && <div style={{height:40}}>&nbsp;</div>}
    </div>)
}

export default ResetPassword